import $ from 'jquery'
const contentsLinkCount = $('.contents-accordion .contents-link-btn > li').length,
 contentsLink = $('.contents-accordion .contents-link-btn'),
 accordionBtn = $('.m__common-btn__accordion')
let contentsLinkHeight = $('.contents-accordion .contents-link-btn').outerHeight(),
 omitHeight = 0

accordionBtn.hide();

if (window.innerWidth >= 768 && contentsLinkCount > 12) {
  omitHeight = 40
  contentsLink.css('height', omitHeight + 'px')
  accordionBtn.show()
} else if (window.innerWidth < 768 && contentsLinkCount > 8) {
  omitHeight = 72
  contentsLink.css('height', omitHeight + 'px')
  accordionBtn.show()
}
accordionBtn.on('click', ()=> {
  if (accordionBtn.hasClass('open')) {
    contentsLink.css('height', omitHeight + 'px')
  } else {
    contentsLink.css('height', contentsLinkHeight + 'px')
  }
})
